import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Overview from './pages/Overview';
import ScheduleEditor from './pages/ScheduleEditor';
import ScheduleDetail from './pages/ScheduleDetail';
import './scheduler.css';
import './scheduler-oc.css';

// Scheduler pages, mounted under /jobs/schedules inside the AppShell.
// The overview runs the Operations Console look (oc-scope, outside the
// legacy .sched frame); detail and editor keep the .sched shell until
// they are redesigned too.
export default function SchedulerApp() {
  return (
    <Routes>
      <Route index element={<div className="sched-oc oc-scope"><Overview /></div>} />
      <Route path="*" element={<SchedShell />} />
    </Routes>
  );
}

function SchedShell() {
  return (
    <div className="sched">
      <div className="sched-shell">
        <Routes>
          <Route path="new" element={<ScheduleEditor />} />
          <Route path=":id" element={<ScheduleDetail />} />
          <Route path=":id/edit" element={<ScheduleEditor />} />
          <Route path="*" element={<Navigate to="/jobs/schedules" replace />} />
        </Routes>
      </div>
    </div>
  );
}
